<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-05 17:55:59
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-11 14:24:48
 * @FilePath: \zhucai_user\src\pages\course\child\rightSide.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <dl v-loading="isLoading" class="width340">
    <dt
      class="BGwhite size16 radius8 gray1 flex pad22 b500 height60px flex between dtTitle"
    >
      相关题库
    </dt>
    <div v-if="list.length > 0" class="info2">
      <div
        class="table-item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div class="table-item-top">
          <div class="img">
            <img src="@/assets/img/home/59.png" alt="" />
          </div>
          <div class="right">
            <div class="name">{{ item.ExerciseName }}</div>
            <div class="value">
              <span>题量：{{ item.TotalNum }}</span>
            </div>
          </div>
        </div>
        <div class="flex mt20">
          <div class="type"># {{ item.ClassifyName }}</div>
          <div class="red">
            ¥ <span class="amout">{{ item.Price }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="rate">
            <span class="mr5">{{ item.StarNum }}</span>
            <el-rate v-model="item.StarNum" disabled text-color="#ff9900">
            </el-rate>
          </div>
          <div class="user">
            <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
          </div>
        </div>
      </div>
    </div>
  </dl>
</template>

<script>
import { Exercise_GetRelatedExercises } from "@/api/qbank";
export default {
  name: "demo",
  data() {
    return {
      list: [],
      count: 0,
      page: 0,
      isLoading: false,
    };
  },
  methods: {
    toDetail(item) {
      console.log(item);
      this.$router.push({
        path: "/qbankDetail",
        query: { ExerciseID: item.ExerciseID },
      });
    },
    getDetail() {
      this.isLoading = true;
      Exercise_GetRelatedExercises({
        ExerciseID: this.$route.query.ExerciseID,
        Size: 2,
      })
        .then((res) => {
          this.list = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style lang="scss" scoped>
.width340 {
  width: 340px;
}
.dtTitle {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 24px;
    left: 0;
    width: 6px;
    height: 20px;
    background: #1d79ff;
    border-radius: 3px;
  }
}
.jiantou {
  .btn {
    cursor: pointer;
    margin-top: -5px;
    width: 28px;
    height: 28px;
  }
}
.info {
  margin-top: 1px;
  width: 340px;
  height: 194px;
  padding: 15px;
  display: flex;
  gap: 20px;
  background: #ffffff;
  border-radius: 10px;
  .info-left {
    width: 130px;
    height: 160px;
    overflow: hidden;
    border-radius: 6px;
    img {
      width: 130px;
      height: 160px;
      border-radius: 6px;
    }
  }
  .info-right {
    position: relative;
    .TeacherName {
      margin-top: 10px;
      font-size: 20px;
      color: #333333;
    }
    .PropValue {
      margin-top: 5px;
      font-size: 16px;
      color: #999999;
    }
    .testBtn {
      position: absolute;
      bottom: 10px;
      height: 36px;
      line-height: 12px;
      background: #ffffff;
      border-radius: 6px;
      font-size: 16px;
      border: 1px solid #cccccc;
    }
  }
}
.info2 {
  margin-top: 1px;
  display: block;
  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 194px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;
    margin-bottom: 10px;
    &:hover {
      transform: scale(1.01);
    }
    .table-item-top {
      padding-top: 15px;
      display: flex;
      gap: 20px;
      .img {
        width: 42px;
        height: 43px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        flex: 1;
        .name {
          font-size: 20px;
          color: #333333;
          display: -webkit-box;
          overflow: hidden; /* 超出的文本隐藏 */
          text-overflow: ellipsis; /* 溢出用省略号显示 */
          -webkit-box-orient: vertical; /* 垂直排列子元素 */
          -webkit-line-clamp: 2; /* 显示的行数 */
        }
        .value {
          display: flex;
          gap: 30px;
          font-size: 16px;
          color: #999999;
        }
      }
    }

    .content {
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden; /* 超出的文本隐藏 */
      text-overflow: ellipsis; /* 溢出用省略号显示 */
      -webkit-box-orient: vertical; /* 垂直排列子元素 */
      -webkit-line-clamp: 2; /* 显示的行数 */
    }
    .img {
      width: 308px;
      height: 231px;
      border-radius: 6px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .type {
        font-size: 16px;
        color: #999999;
      }
      .amout {
        font-size: 24px;
        font-weight: bold;
      }
      .red {
        font-size: 16px;
        color: #e12a14;
    font-weight: bold;

      }
      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #666666;
        img {
          width: 12px;
          height: 17px;
          margin-right: 9px;
        }
      }
      .rate {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 20px;
        color: #e12a14;
      }
    }
  }
}
</style>
